import { useState, useCallback, useTransition } from 'react';

export function useModals() {
  const [, startTransition] = useTransition();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPricingModal, setShowPricingModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [showAnimationSettings, setShowAnimationSettings] = useState(false);
  const [showAnalysisHistory, setShowAnalysisHistory] = useState(false);
  const [showMyAnalyses, setShowMyAnalyses] = useState(false);
  const [showAlertSettings, setShowAlertSettings] = useState(false);
  const [showMonitoringGuide, setShowMonitoringGuide] = useState(false);
  const [showLabTest, setShowLabTest] = useState(false);
  const [showDomainGroupsModal, setShowDomainGroupsModal] = useState(false);
  const [showDataSourceInfo, setShowDataSourceInfo] = useState(false);
  const [showBadgesPanel, setShowBadgesPanel] = useState(false);
  const [showAgencyPanel, setShowAgencyPanel] = useState(false);
  const [showIntegrationGuide, setShowIntegrationGuide] = useState(false);
  const [authMode, setAuthMode] = useState('login');

  const openAuth = useCallback((mode = 'login') => {
    setAuthMode(mode);
    setShowAuthModal(true);
  }, []);

  const closeAuth = useCallback(() => {
    setShowAuthModal(false);
  }, []);

  const openPricing = useCallback(() => setShowPricingModal(true), []);
  const closePricing = useCallback(() => setShowPricingModal(false), []);

  const openExport = useCallback(() => setShowExportModal(true), []);
  const closeExport = useCallback(() => setShowExportModal(false), []);

  const openAdmin = useCallback(() => setShowAdminPanel(true), []);
  const closeAdmin = useCallback(() => setShowAdminPanel(false), []);

  const openAnimationSettings = useCallback(() => setShowAnimationSettings(true), []);
  const closeAnimationSettings = useCallback(() => setShowAnimationSettings(false), []);

  const openAnalysisHistory = useCallback(() => setShowAnalysisHistory(true), []);
  const closeAnalysisHistory = useCallback(() => setShowAnalysisHistory(false), []);

  const openMyAnalyses = useCallback(() => setShowMyAnalyses(true), []);
  const closeMyAnalyses = useCallback(() => setShowMyAnalyses(false), []);

  const openAlertSettings = useCallback(() => {
    startTransition(() => setShowAlertSettings(true));
  }, []);
  const closeAlertSettings = useCallback(() => setShowAlertSettings(false), []);

  const openMonitoringGuide = useCallback(() => {
    startTransition(() => setShowMonitoringGuide(true));
  }, []);
  const closeMonitoringGuide = useCallback(() => setShowMonitoringGuide(false), []);

  const openLabTest = useCallback(() => {
    startTransition(() => setShowLabTest(true));
  }, []);
  const closeLabTest = useCallback(() => setShowLabTest(false), []);

  const openDomainGroups = useCallback(() => setShowDomainGroupsModal(true), []);
  const closeDomainGroups = useCallback(() => setShowDomainGroupsModal(false), []);

  const toggleDataSourceInfo = useCallback(() => setShowDataSourceInfo(prev => !prev), []);

  const openBadges = useCallback(() => {
    startTransition(() => setShowBadgesPanel(true));
  }, []);
  const closeBadges = useCallback(() => setShowBadgesPanel(false), []);

  const openAgency = useCallback(() => {
    startTransition(() => setShowAgencyPanel(true));
  }, []);
  const closeAgency = useCallback(() => setShowAgencyPanel(false), []);

  const openIntegrationGuide = useCallback(() => {
    startTransition(() => setShowIntegrationGuide(true));
  }, []);
  const closeIntegrationGuide = useCallback(() => setShowIntegrationGuide(false), []);

  const closeAll = useCallback(() => {
    setShowAuthModal(false);
    setShowPricingModal(false);
    setShowExportModal(false);
    setShowAdminPanel(false);
    setShowAnimationSettings(false);
    setShowAnalysisHistory(false);
    setShowMyAnalyses(false);
    setShowAlertSettings(false);
    setShowMonitoringGuide(false);
    setShowLabTest(false);
    setShowDomainGroupsModal(false);
    setShowDataSourceInfo(false);
    setShowBadgesPanel(false);
    setShowAgencyPanel(false);
    setShowIntegrationGuide(false);
  }, []);

  return {
    showAuthModal,
    setShowAuthModal,
    showPricingModal,
    setShowPricingModal,
    showExportModal,
    setShowExportModal,
    showAdminPanel,
    setShowAdminPanel,
    showAnimationSettings,
    setShowAnimationSettings,
    showAnalysisHistory,
    setShowAnalysisHistory,
    showMyAnalyses,
    setShowMyAnalyses,
    showAlertSettings,
    setShowAlertSettings,
    showMonitoringGuide,
    setShowMonitoringGuide,
    showLabTest,
    setShowLabTest,
    showDomainGroupsModal,
    setShowDomainGroupsModal,
    showDataSourceInfo,
    setShowDataSourceInfo,
    authMode,
    setAuthMode,
    openAuth,
    closeAuth,
    openPricing,
    closePricing,
    openExport,
    closeExport,
    openAdmin,
    closeAdmin,
    openAnimationSettings,
    closeAnimationSettings,
    openAnalysisHistory,
    closeAnalysisHistory,
    openMyAnalyses,
    closeMyAnalyses,
    openAlertSettings,
    closeAlertSettings,
    openMonitoringGuide,
    closeMonitoringGuide,
    openLabTest,
    closeLabTest,
    openDomainGroups,
    closeDomainGroups,
    toggleDataSourceInfo,
    showBadgesPanel,
    setShowBadgesPanel,
    openBadges,
    closeBadges,
    showAgencyPanel,
    setShowAgencyPanel,
    openAgency,
    closeAgency,
    showIntegrationGuide,
    setShowIntegrationGuide,
    openIntegrationGuide,
    closeIntegrationGuide,
    closeAll
  };
}

export default useModals;
